import { useCallback } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { useAuthStore } from '@store/auth.store'
import { LogoutReason } from '@services/auth.service'

export function useLogout() {
  const logout = useAuthStore((state) => state.logout)
  const queryClient = useQueryClient()

  return useCallback(
    (reason?: LogoutReason) => {
      queryClient.removeQueries({ queryKey: ['current-user'] })
      return logout(reason)
    },
    [logout, queryClient],
  )
}
